import React, { useEffect, useState } from 'react';
import Unsplash from 'unsplash-js';
import { Paper, Box } from '@material-ui/core';
import AppIcon from 'assets/img/icon-1024.png';
import { useStyles } from './style';
import LoginForm from './LoginForm';

const Login = () => {
  const [backgroundImage, setBackGroundImage] = useState<string>('');

  const classes = useStyles({ backgroundImage });

  useEffect(() => {
    const accessKey = process.env.REACT_APP_UNSPLASH_ACCESS_TOKEN || '';

    const unplash = new Unsplash({
      accessKey
    });

    const fetchBackgroundImages = async () => {
      try {
        const images = await unplash.photos.getPhoto('W9OKrxBqiZA');

        const response = await images.json();

        if (response) {
          const { urls: { full } = { full: '' } } = response;

          setBackGroundImage(`url('${full}')`);
        }
      } catch (e) {
        console.log('Unable to fetch pictures', e);
      }

      return () => setBackGroundImage('');
    };

    fetchBackgroundImages();
  }, []);

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper}>
        <img className={classes.appIcon} src={AppIcon} alt="App Icon" />
        <LoginForm />
      </Paper>
    </Box>
  );
};

export default Login;
